import type { GiyusClient } from '@giyus/api-client';
import { createContext, useContext } from 'react';

export const ApiClientContext = createContext<GiyusClient | null>(null);

/** Cliente tipado da API (Parte 14.2): único caminho HTTP da SPA (`giyus/no-raw-fetch`). */
export function useApiClient(): GiyusClient {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error('useApiClient must be used within <ApiClientProvider>.');
  }
  return client;
}
